/**
 * Created by baird on 2016/12/30.
 */
import Vue from 'vue';
import Vuex from 'vuex';

import account from './modules/account';
import pagestate from './modules/pagestate';

import layout from './modules/layout';
import theme from './modules/theme';
import system from './modules/system';
Vue.use(Vuex);
const store = new Vuex.Store({
    modules: {
        layout,
        account,
        theme,
        system,
        pagestate
    },
    strict: process.env.NODE_ENV !== 'production' //是否开启严格模式
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js